'use client';

import { Layout } from 'components/ring-claim/Layout';
import { Form } from 'components/ring-claim/Form';
import { AirRingColors } from 'content/products/ring';

const RingOrder = () => {
  return (
    <main>
      <div>
        <Layout baseImage="/web_v2/backgrounds/ring-claim-fox-doc-v2.png">
          <Form defaultColorByPage={AirRingColors.MATTE_GREY} />
        </Layout>
      </div>
    </main>
  );
};

export default RingOrder;
